import { ref } from 'vue'
import { getStrategyTags } from '@/strategies/api'
import type { StrategyTags } from './strategy_types'

export function useStrategyTags() {
  const tags = ref<StrategyTags | null>(null)
  const loadingOptions = ref(true)
  const optionsError = ref('')

  async function loadTags() {
    try {
      tags.value = await getStrategyTags({ published: 1 })
    } catch {
      optionsError.value = 'Filter options could not be loaded. Please reload the page to try again.'
    } finally {
      loadingOptions.value = false
    }
  }

  loadTags()

  return { tags, loadingOptions, optionsError }
}
